import { makeStyles } from "tss-react/mui";

interface IParams {
    isAlertModal: boolean;
    isMobile: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    dialog: {
        "& .MuiDialog-paper": {
            padding: theme.spacing(2),
            minWidth: props.isMobile ? 0 : 700,
        },
    },
    dialogTitle: {
        "& .MuiTypography-root": {
            textAlign: "center",
        },
    },
    dialogContent: {
        textAlign: props.isAlertModal ? "center" : "unset",
    },
    dialogActions: {
        flexDirection: props.isMobile ? "column-reverse" : "row",
        justifyContent: "center",
    },
}));
